import Entry from 'admin-config/lib/Entry';

export default function brandHome($rootScope) {
    return {
        scope: {
            'default': '&'
        },
        restrict: 'E',
        link: function(scope) {
            scope.lang = $rootScope.current_language;

            scope.get_lang = function(){
                return $rootScope.current_language;
            }
        },
        template:
            `
            <a href="/?lang={{ get_lang() }}" class="logo"></a>
            `
    };
};

brandHome.$inject = ['$rootScope'];


/** WEBPACK FOOTER **
 ** ./js/directives/brand_home.js
 **/